import { Button } from '@mantine/core';
import { IconMapPinOff } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { EmptyState } from '../components/EmptyState';

export function NotFound() {
  return (
    <EmptyState
      variant="warn"
      icon={<IconMapPinOff size={28} stroke={2} />}
      title="That page isn't here"
      body="The link may be old, or the page has moved. Try the search bar, or head back to Home."
      action={
        <Button component={Link} to="/" variant="default">
          Back to Home
        </Button>
      }
    />
  );
}
